import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Palette } from "lucide-react";

interface StoreCustomizerProps {
  storeId: string;
  onUpdate: () => void;
}

const StoreCustomizer = ({ storeId, onUpdate }: StoreCustomizerProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Palette className="h-5 w-5" />
          Store Customization
        </CardTitle>
        <CardDescription>Customize your store appearance and branding</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">Store ID: {storeId}</p>
          <div className="p-8 border-2 border-dashed rounded-lg text-center">
            <Palette className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
            <h3 className="font-medium mb-2">Customization Tools Coming Soon</h3>
            <p className="text-sm text-muted-foreground">
              Logo upload, color pickers, and theme options will be available here.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StoreCustomizer;
